import { Button } from '@smartgift/frontend-toolkit';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { TableProducts } from '@hero/components/organisms/TableProducts';
import { ReviewSection } from '@hero/molecules';

import * as S from './style';

export function GiftCollectionSection({
  stepIndex = 1,
  isCompleted = true,
  products = [],
  onEdit = () => {}
}) {
  const { t } = useTranslation();

  return (
    <ReviewSection
      stepIndex={stepIndex}
      isCompleted={isCompleted}
      title={t('giftCollection')}
      subTitle={t('giftCollectionDescription')}
      headerChildren={
        <Button size="sm" variant="outlined" onClick={onEdit}>
          {t('editCollection')}
        </Button>
      }
    >
      <S.GCBodyContent>
        {!!products.length && (
          <TableProducts
            products={products}
            maxVisibleProducts={6}
            imageSize={{ width: 80, height: 88 }}
          />
        )}
      </S.GCBodyContent>
    </ReviewSection>
  );
}

GiftCollectionSection.propTypes = {
  stepIndex: PropTypes.number,
  isCompleted: PropTypes.bool,
  products: PropTypes.array,
  onEdit: PropTypes.func
};
